/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountNativeDetailsForDropbox extends models.ServiceAccountNativeDetailsBaseForSaasOtherServices {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountNativeDetailsForDropbox");
    }

    getFixupPrototypeFunction() { return ServiceAccountNativeDetailsForDropbox.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountNativeDetailsForDropbox>): ServiceAccountNativeDetailsForDropbox {
        let obj = Object.assign(new ServiceAccountNativeDetailsForDropbox(), model);
        ServiceAccountNativeDetailsForDropbox.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountNativeDetailsForDropbox>): ServiceAccountNativeDetailsForDropbox {
        if (!model) return null;
        return ServiceAccountNativeDetailsForDropbox.newInstance(<ServiceAccountNativeDetailsForDropbox> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountNativeDetailsForDropbox) {
        if (!obj) return;

        models.ServiceAccountNativeDetailsForDropbox.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountNativeDetailsForDropbox): boolean {
        if (models.ServiceAccountNativeDetailsBaseForSaasOtherServices.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountNativeDetailsForDropbox.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
